import { Component, OnInit, Injectable, ChangeDetectionStrategy } from '@angular/core';
import { AppUserDevice } from '../../../../shared/interfaces/app/app-user-device';

@Component({
    selector: 'app-device',
    templateUrl: './device.component.html',
    styleUrls: ['./device.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Injectable()
export class DeviceComponent implements OnInit {
  devices: AppUserDevice[] = [];
  constructor(
    ) {
  }

  ngOnInit() {
  }
}
